module.exports = __webpack_public_path__ + "img/23ne.f67df45b.svg";